import React from "react";
import { FaTimes } from "react-icons/fa";
import "./ReferencesPanel.scss";
import useT from "utils/hooks/useT";

const ReferencesPanel = ({ isOpen, onClose, links }) => {
  const { t } = useT("common");
  return (
    <div className={`references-panel ${isOpen ? "open" : ""}`}>
      <div className="references-panel-header">
        <h2>{t("references")}</h2>
        <button className="close-button" onClick={onClose}>
          <FaTimes />
        </button>
      </div>
      <div className="references-panel-content">
        {links?.length > 0 ? (
          links.map((link, index) => (
            <React.Fragment key={index}>
              <div className="reference-item">
                <a
                  target={link.url.includes(".pdf") ? "_self" : "_blank"}
                  href={link.url}
                  rel="noopener noreferrer"
                  className="reference-link"
                >
                {link.docId
                  ? `[${link.docId}] - ${link.tag}${
                      // Use a regex to check if pageNo is in the form of "<number>-<number>"
                      link.pageNo && /^\d+-\d+$/.test(link.pageNo)
                        ? ` (pages ${link.pageNo})`
                        : ''
                    }`
                  : link.tag}
                </a>
              </div>
              {/* Add divider except after the last link */}
              {index < links.length - 1 && <hr className="divider" />}
            </React.Fragment>
          ))
        ) : (
          <p>{t("noReferencesAvailable")}</p>
        )}
      </div>
    </div>
  );
};

export default ReferencesPanel;

